import styled from "styled-components";
const PageContent = styled.div `
  max-width: 1000px;
  margin: 0 auto;
`;
export default PageContent;
